module.exports = __webpack_public_path__ + "img/dlsjjkxt2.3df39152.jpg";